import { api, useCurrentUser } from '@cma/app'
import {
  UpdatePlatformFolderMutation,
  UpdatePlatformFolderMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useUpdatePlatformClientFolder() {
  const queryClient = useQueryClient()
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMutation<
    UpdatePlatformFolderMutation,
    Error,
    UpdatePlatformFolderMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation UpdatePlatformFolder($folderId: ID, $displayName: String) {
          updatePlatformFolder(folderId: $folderId, displayName: $displayName) {
            errors
            folder {
              id
              createdAt
              name
              updatedAt
            }
          }
        }
      `
      return api<
        UpdatePlatformFolderMutation,
        UpdatePlatformFolderMutationVariables
      >({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformContent',
          { id: currentUser?.account?.id }
        ])
      }
    }
  )
}
